import './CampoObrigatorio.css';

const CampoObrigatorio = () => {
    return <span className='campo-obrigatorio-abertura-chamado'>*</span>
}

export default CampoObrigatorio;